import { CButton, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CForm, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CLabel } from '@coreui/react';
import * as React from 'react';
import { Table } from 'reactstrap';
import { IMessageBox, IPoolInfo, IPoolMappingEntry } from '../abstraction';
import { AppLabels } from '../core/AppLabels';

interface ISaveConfig {
	savePoolConfig(mappings: IPoolMappingEntry[], pools: string[]) : Promise<boolean>;
}

interface IProps {
	availablePools: IPoolInfo[];
	mappings: IPoolMappingEntry[];
	pools: string[];
	saveProvider: ISaveConfig;
	msgboxProvider: IMessageBox;
}

interface IState {
	newPoolName: string;
	newWsName: string;
	newPrimary: string;
	newSecondary: string;

	dropDownSecondary: boolean;
	isAddActive: boolean;
	isDirty: boolean;
}

// Affiche la liste du pool de pools ainsi que les mapping en place sur les WS
// 
export class KPoolMapping extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			newPoolName: "",
			newWsName: "",
			newPrimary: "",
			newSecondary: "",
			dropDownSecondary: false,
			isAddActive: false,
			isDirty: false,
		};

	}

	//#region quelques méthode métier

	// Indique qu'une modification a été réalisée
	setDirty = (value: boolean) => {
		this.setState({ isDirty: value })
	}

	// Supprime une ligne du tableau des mappings
	// wsName : code du pool à supprimer
	removeLine = (wsName: string) => {
		this.props.mappings.splice(this.props.mappings.findIndex(p => p.wsName == wsName), 1);
		this.setDirty(true);
		this.forceUpdate();
	}

	// Supprime une ligne du tableau des pools par défaut
	// wsName : code du pool à supprimer
	removePool = (poolName: string) => {
		this.props.pools.splice(this.props.pools.findIndex(p => p == poolName), 1);
		this.setDirty(true);
		this.forceUpdate();
	}

	//#endregion quelques méthode métier

	//#region évènements de gestion des modifs

	onNewWsNameChange = (event) => {
		this.setState({ newWsName: event.target.value }, () => { this.setAddState(); });
	}

	onNewPoolNameChange = (pool: string) => {
		this.setState({ newPoolName: pool }, () => { this.setAddState(); });
	}

	onPrimaryPoolChange = (pool: string) => {
		this.setState({ newPrimary: pool }, () => { this.setAddState(); });
	}

	onSecondaryPoolChange = (pool) => {
		this.setState({ newSecondary: pool }, () => { this.setAddState(); });
	}

	// Défini l'état du bouton AJOUTER selon les saisies effectuées
	private setAddState = () => {

		if ((this.state.newWsName != "") && (this.state.newPrimary != "") && (this.state.newSecondary != ""))
			this.setState({ isAddActive: true });
		else
			this.setState({ isAddActive: false });
	}
	//#endregion

	//#region Local events
	// Click sur ajouter une entrée dans la liste des pools
	onAddPoolClick = () => {
		if (this.props.pools.filter(p => p == this.state.newPoolName)[0]) {
			this.props.msgboxProvider.MessageBox(AppLabels.newPool, AppLabels.itemAlreadyInList, 3);
		}
		else {
			this.props.pools.push(this.state.newPoolName);
			this.setDirty(true);
			this.forceUpdate();
		}
	}

	// Click sur ajouter une entrée dans la liste des mappings
	onAddClick = () => {
		let newItem: IPoolMappingEntry = {
			primaryPool: this.state.newPrimary,
			secondaryPool: this.state.newSecondary,
			wsName: this.state.newWsName.toUpperCase(),
		}

		if (this.props.mappings.filter(p => p.wsName == newItem.wsName)[0]) {
			this.props.msgboxProvider.MessageBox(AppLabels.newMapping, AppLabels.itemAlreadyInList, 3);
		}
		else {
			this.props.mappings.push(newItem);
			this.setDirty(true);
			this.forceUpdate();
		}
	}

	// Click sur appliquer les modifs.
	// Il va falloir enregistrer
	onApplyClick = () => {
		this.props.saveProvider.savePoolConfig(this.props.mappings, this.props.pools);
		this.setDirty(false);
	}

	//#endregion

	//#region Rendus

	render() {
		return (
			<div>
				<div className="KPoolMappingList KAdminBorder">
					<div className="KControl">
						<CLabel >{AppLabels.defaultPoolList}</CLabel>
						<div className=" KControlTable" >
							<Table size="sm" >
								<thead>
									<tr>
										<th className="KTableHeaderCol">{AppLabels.poolName}</th>
										<th className="KTableHeaderCol">{AppLabels.action}</th>
									</tr>
								</thead>
								<tbody>
									{
										this.props.pools.map((row, index) => {
											return (
												<tr key={index}>
													<td className="">{row}</td>
													<td className=""><CButton onClick={() => { this.removePool(row) }} size="sm" color="danger">X</CButton></td>
												</tr>
											);
										})
									}

								</tbody>
							</Table>
						</div>
					</div>
					<CForm inline>
						<CFormGroup className="mb-2 mr-sm-2 mb-sm-0">
							<CLabel className="mr-sm-2">{AppLabels.pool}</CLabel>
							<CInputGroup>
								<CInput type="text" readOnly={true} name="primaryPool" placeholder={AppLabels.selectFromList} value={this.state.newPoolName} />
								<CInputGroupAppend>
									<CDropdown  >
										<CDropdownToggle caret />
										<CDropdownMenu >{
											this.props.availablePools.map((row, index) => {
												return (
													<CDropdownItem key={index} onClick={() => this.onNewPoolNameChange(row.poolName)}>{row.poolName}</CDropdownItem>
												)
											})
										}
										</CDropdownMenu>
									</CDropdown>
								</CInputGroupAppend>
							</CInputGroup>
						</CFormGroup>
						<CButton disabled={!this.state.newPoolName} onClick={() => { this.onAddPoolClick() }} size="sm" color="danger">Add</CButton>
					</CForm>
					<hr />
					<div className="KControl">
						<CLabel >{AppLabels.poolMappingTable}</CLabel>
						<div className="KControlTable" >
							<Table size="sm" >
								<thead>
									<tr>
										<th className="KTableHeaderCol" >{AppLabels.webServiceName}</th>
										<th className="KTableHeaderCol" >{AppLabels.primaryPool}</th>
										<th className="KTableHeaderCol" >{AppLabels.secondaryPool}</th>
										<th className="KTableHeaderCol" >{AppLabels.action}</th>
									</tr>
								</thead>
								<tbody>
									{
										this.props.mappings.map((row, index) => {
											return (
												<tr key={index}>
													<td className="">{row.wsName}</td>

													<td className="">{row.primaryPool}</td>
													<td className="">{row.secondaryPool}</td>

													<td className=""><CButton onClick={() => { this.removeLine(row.wsName) }} size="sm" color="danger">X</CButton></td>
												</tr>
											);
										})
									}

								</tbody>
							</Table>
						</div>
					</div>
					<CForm inline>
						<CFormGroup className="mb-2 mr-sm-2 mb-sm-0">
							<CLabel className="mr-sm-2">{AppLabels.webServiceName}</CLabel>
							<CInput type="text" name="wsName" placeholder={AppLabels.webServiceName} value={this.state.newWsName} onChange={this.onNewWsNameChange} />
						</CFormGroup>
						<CFormGroup className="mb-2 mr-sm-2 mb-sm-0">
							<CLabel className="mr-sm-2">{AppLabels.primaryPool}</CLabel>
							<CInputGroup>
								<CInput type="text" readOnly={true} name="primaryPool" placeholder={AppLabels.selectFromList} value={this.state.newPrimary} />
								<CInputGroupAppend >
									<CDropdown  >
										<CDropdownToggle caret />
										<CDropdownMenu >{
											this.props.availablePools.map((row, index) => {
												return (
													<CDropdownItem key={index} onClick={() => this.onPrimaryPoolChange(row.poolName)}>{row.poolName}</CDropdownItem>
												)
											})
										}
										</CDropdownMenu>
									</CDropdown>
								</CInputGroupAppend>
							</CInputGroup>
						</CFormGroup>
						<CFormGroup className="mb-2 mr-sm-2 mb-sm-0">
							<CLabel className="mr-sm-2">{AppLabels.secondaryPool}</CLabel>
							<CInputGroup>
								<CInput type="text" readOnly={true} name="secondaryPool" placeholder={AppLabels.selectFromList} value={this.state.newSecondary} />
								<CInputGroupAppend>
									<CDropdown  >
										<CDropdownToggle caret />
										<CDropdownMenu >{
											this.props.availablePools.map((row, index) => {
												return (
													<CDropdownItem key={index} onClick={() => this.onSecondaryPoolChange(row.poolName)}>{row.poolName}</CDropdownItem>
												)
											})
										}
										</CDropdownMenu>
									</CDropdown>
								</CInputGroupAppend>
							</CInputGroup>
						</CFormGroup>
						<CButton disabled={!this.state.isAddActive} onClick={() => { this.onAddClick() }} size="sm" color="danger">{AppLabels.add}</CButton>
					</CForm>

					<div className="buttonbar" >
						<CButton disabled={!this.state.isDirty} onClick={() => { this.onApplyClick() }} size="sm" color="success">{AppLabels.apply}</CButton>
					</div>
				</div>
			</div>
		);
	}

	//#endregion Rendus
}
